import styled from 'styled-components';

const TextInTh = styled.div`
  color: #4a6cbb;
  margin-top: 2px;
  font-weight: 400;
`;

export default TextInTh;
